exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".VirtualSelectGrid {\n    z-index: 1;\n}\n\n.VirtualizedSelectOption {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    -webkit-align-items: center;\n    align-items: center;\n    padding: 0 0.5rem;\n}\n.VirtualizedSelectFocusedOption {\n    background-color: rgba(0, 126, 255, 0.1);\n}\n.VirtualizedSelectDisabledOption {\n    opacity: 0.5;\n}\n", ""]);

// exports
